module.exports = __webpack_public_path__ + "img/Baujahr.eefac8fc.svg";